import { Injectable } from '@angular/core';
import { DataConnection } from '@nimmsta/ng-commons-lib/models';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';

@Injectable({ providedIn: 'root' })
export class DataConnectionTemplateService extends WorkflowDataService<DataConnection> {
  protected override get apiEndpoint(): string {
    return '/dataconnection/template';
  }
}
